import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'

export function getEmailParticipantsIds({
  bcc = EMPTY_LIST,
  cc = EMPTY_LIST,
  owner = EMPTY_OBJECT,
  recipients = EMPTY_LIST,
  to = EMPTY_LIST,
} = EMPTY_OBJECT) {
  const ids = getItemsIds([...to, ...bcc, ...cc, ...recipients, owner])

  return [...new Set(ids.filter(Boolean))]
}
